import { render } from "./TimelineDemo.vue?vue&type=template&id=3c652f9e&scoped=true"
import script from "./TimelineDemo.vue?vue&type=script&lang=js"
export * from "./TimelineDemo.vue?vue&type=script&lang=js"

import "./TimelineDemo.vue?vue&type=style&index=0&id=3c652f9e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c652f9e"]])

export default __exports__